'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cleanLegacy;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var legacyCookies = ['RP_PS_SESSIONID', 'RP_SP_DATA0', 'RP_SP_SESSIONID', 'RP_SS_SESSIONID', 'RP_ST_DATA0', 'RP_ST_DATA1', 'RP_ST_SESSIONID'];

var domain = window.location.hostname.split('.').slice(-2).join('.');

function cleanLegacy() {
    var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : legacyCookies;

    cookies.forEach(function (name) {
        _jsCookie2.default.remove(name);
        _jsCookie2.default.remove(name, { domain: domain });
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-cookie/lib/legacy.js
// module id = 1367
// module chunks = 1